import React, { useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { Eye, X, Home, Hammer, Users, Calendar } from "lucide-react";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Comprehensive gallery items using all available images from /image/ folder
  const galleryItems = [
    // Kitchen Projects
    { 
      id: 1, 
      type: "image", 
      src: "/image/0d5126ed-1e60-4b60-a586-00c2cd83f2db.jpg",
      category: "kitchen",
      title: "Modern Kitchen Renovation",
      year: "2024",
      description: "State-of-the-art kitchen with contemporary finishes"
    },
    { 
      id: 2, 
      type: "image", 
      src: "/image/73701879-b173-4d6b-9157-0df1ba1d3e5d.jpg",
      category: "kitchen",
      title: "Gourmet Kitchen Design",
      year: "2023",
      description: "Chef-inspired workspace with premium appliances"
    },
    { 
      id: 3, 
      type: "image", 
      src: "/image/8c5ad908-664d-4d5f-a65b-e0e2471c0d59.jpg",
      category: "kitchen",
      title: "Classic Kitchen Remodel",
      year: "2024",
      description: "Timeless design with modern functionality"
    },
    { 
      id: 4, 
      type: "image", 
      src: "/image/99ff1b50-1c1e-4202-8e1b-080ffcb85ed6.jpg",
      category: "kitchen",
      title: "Custom Kitchen Island",
      year: "2023",
      description: "Centerpiece kitchen island with storage solutions"
    },
    
    // Living Areas
    { 
      id: 5, 
      type: "image", 
      src: "/image/3b201da7-0207-48c3-bffd-ecb8635f7f1e.jpg",
      category: "living",
      title: "Contemporary Living Space",
      year: "2024",
      description: "Open concept design with natural lighting"
    },
    { 
      id: 6, 
      type: "image", 
      src: "/image/8b2a655e-bcee-43b8-988b-c4aabdefbf81.jpg",
      category: "living",
      title: "Elegant Living Room",
      year: "2023",
      description: "Sophisticated entertaining space"
    },
    { 
      id: 7, 
      type: "image", 
      src: "/image/a7fbf924-af8b-41aa-8655-b4894a66d776.jpg",
      category: "living",
      title: "Family Room Transformation",
      year: "2023",
      description: "Comfortable family gathering space"
    },
    { 
      id: 8, 
      type: "image", 
      src: "/image/e1c3e786-ca8d-439f-b07c-5ed6bcafedb2.jpg",
      category: "living",
      title: "Open Concept Living",
      year: "2024",
      description: "Seamless flow between living spaces"
    },

    // Bathroom Projects
    { 
      id: 9, 
      type: "image", 
      src: "/image/555ba06c-7a90-4563-8f78-a6cff15a9ee7.jpg",
      category: "bathroom",
      title: "Spa-Inspired Bathroom",
      year: "2023",
      description: "Relaxing spa-like atmosphere"
    },
    { 
      id: 10, 
      type: "image", 
      src: "/image/8dfcf695-b4cf-4851-84dd-736654fe6726.jpg",
      category: "bathroom",
      title: "Luxury Bathroom Suite",
      year: "2024",
      description: "Spa-like retreat with premium fixtures"
    },
    { 
      id: 11, 
      type: "image", 
      src: "/image/92861d7f-b966-46ee-8895-01396e099bbc.jpg",
      category: "bathroom",
      title: "Modern Bathroom Design",
      year: "2023",
      description: "Contemporary bathroom with luxury finishes"
    },

    // Bedroom Projects
    { 
      id: 12, 
      type: "image", 
      src: "/image/523ffe99-3025-4bc5-b382-aafcb294bc34.jpg",
      category: "bedroom",
      title: "Master Bedroom Retreat",
      year: "2024",
      description: "Tranquil retreat with custom details"
    },
    { 
      id: 13, 
      type: "image", 
      src: "/image/6b6d590d-5c76-4b00-8160-7057eb2c44f3.jpg",
      category: "bedroom",
      title: "Serene Bedroom Design",
      year: "2023",
      description: "Peaceful sanctuary with custom built-ins"
    },
    { 
      id: 14, 
      type: "image", 
      src: "/image/b55dd0d0-5a68-43d8-aedf-97b8b80d04ea.jpg",
      category: "bedroom",
      title: "Contemporary Bedroom",
      year: "2024",
      description: "Modern comfort with elegant styling"
    },

    // Exterior Projects
    { 
      id: 15, 
      type: "image", 
      src: "/image/270ffe8e-1727-4923-8ccb-a8e8e873163f.jpg",
      category: "exterior",
      title: "Garden Landscape Design",
      year: "2023",
      description: "Beautiful outdoor living transformation"
    },
    { 
      id: 16, 
      type: "image", 
      src: "/image/8676f577-587c-4bad-bb19-a03d6fd1ec1d.jpg",
      category: "exterior",
      title: "Outdoor Entertainment Area",
      year: "2024",
      description: "Perfect space for hosting and relaxation"
    },
    { 
      id: 17, 
      type: "image", 
      src: "/image/a7f9debe-dd05-41e1-846e-fc66a6361926.jpg",
      category: "exterior",
      title: "Stunning Exterior Design",
      year: "2023",
      description: "Enhanced curb appeal with modern landscaping"
    },
    { 
      id: 18, 
      type: "image", 
      src: "/image/c546cbd9-927a-4d5a-be37-dcf7ad185742.jpg",
      category: "exterior",
      title: "Curb Appeal Enhancement",
      year: "2024",
      description: "Dramatic exterior transformation"
    },

    // Interior Design Projects
    { 
      id: 19, 
      type: "image", 
      src: "/image/2913649c-7dbc-4b5a-af4a-f47f93e30cdf.jpg",
      category: "interior",
      title: "Modern Interior Styling",
      year: "2024",
      description: "Contemporary design with clean lines"
    },
    { 
      id: 20, 
      type: "image", 
      src: "/image/3f04ed8b-1955-42ad-a9cf-7bf2ae8fd3d9.jpg",
      category: "interior",
      title: "Interior Design Excellence",
      year: "2023",
      description: "Sophisticated interior styling"
    },
    { 
      id: 21, 
      type: "image", 
      src: "/image/538de46c-a38d-4e45-9f93-36600d85f47f.jpg",
      category: "interior",
      title: "Custom Interior Features",
      year: "2024",
      description: "Bespoke design elements and finishes"
    },
    { 
      id: 22, 
      type: "image", 
      src: "/image/82bc6a7a-708a-439b-b937-d7ed8b18bca7.jpg",
      category: "interior",
      title: "Luxury Interior Design",
      year: "2023",
      description: "High-end materials and craftsmanship"
    },
    { 
      id: 23, 
      type: "image", 
      src: "/image/8ed634c2-1bf5-45f3-a64c-b8123f318b0c.jpg",
      category: "interior",
      title: "Artistic Interior Concepts",
      year: "2024",
      description: "Creative and innovative design solutions"
    },
    { 
      id: 24, 
      type: "image", 
      src: "/image/e351ead9-621a-4140-a2ff-c8fbdf26a2a2.jpg",
      category: "interior",
      title: "Complete Interior Makeover",
      year: "2023",
      description: "Total transformation of living spaces"
    }
  ];

  return (
    <div className="min-h-screen pt-16 bg-gradient-to-br from-slate-50 via-gray-50 to-zinc-100">
      {/* Header Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Design <span className="text-gradient bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">Portfolio</span>
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-orange-500 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Discover Aaron's exceptional portfolio featuring comprehensive property transformations across San Diego County. 
              From modern kitchens to luxury bathrooms, each project represents innovative design, quality craftsmanship, 
              and opportunities for 50+ skilled local artisans.
            </p>
            
            {/* Enhanced Stats Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
              <Card className="bg-white/90 backdrop-blur-sm border-amber-200 hover:shadow-xl transition-all duration-300 group">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-amber-600 mb-2 group-hover:scale-110 transition-transform duration-300">24+</div>
                  <div className="text-gray-600 font-medium">Portfolio Items</div>
                </CardContent>
              </Card>
              <Card className="bg-white/90 backdrop-blur-sm border-orange-200 hover:shadow-xl transition-all duration-300 group">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2 group-hover:scale-110 transition-transform duration-300">11</div>
                  <div className="text-gray-600 font-medium">Years Experience</div>
                </CardContent>
              </Card>
              <Card className="bg-white/90 backdrop-blur-sm border-red-200 hover:shadow-xl transition-all duration-300 group">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2 group-hover:scale-110 transition-transform duration-300">50+</div>
                  <div className="text-gray-600 font-medium">Local Craftsmen</div>
                </CardContent>
              </Card>
              <Card className="bg-white/90 backdrop-blur-sm border-amber-200 hover:shadow-xl transition-all duration-300 group">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-amber-600 mb-2 group-hover:scale-110 transition-transform duration-300">2014</div>
                  <div className="text-gray-600 font-medium">Since Founded</div>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Enhanced Gallery Grid with Masonry Layout */}
          <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6">
            {galleryItems.map((item, index) => (
              <div
                key={item.id}
                className="break-inside-avoid mb-6 group cursor-pointer transform transition-all duration-500 hover:-translate-y-2"
                style={{ animationDelay: `${index * 50}ms` }}
                onClick={() => setSelectedImage(item)}
              >
                <Card className="bg-white/95 backdrop-blur-sm border-amber-200 shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden">
                  <div className="relative overflow-hidden">
                    <img
                      src={item.src}
                      alt={item.title}
                      className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                    />
                    
                    {/* Enhanced Hover Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center">
                      <div className="transform scale-75 group-hover:scale-100 transition-all duration-300">
                        <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-xl">
                          <Eye className="w-6 h-6 text-amber-600" />
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <CardContent className="p-6">
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-2 sm:p-4 backdrop-blur-sm">
          {/* Close Button */}
          <div className="absolute top-4 right-4 sm:top-6 sm:right-6 z-10">
            <Button
              onClick={() => setSelectedImage(null)}
              variant="ghost"
              className="p-2 sm:p-3 bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-all duration-200 text-white hover:text-white"
            >
              <X className="w-6 h-6" />
            </Button>
          </div>
          
          {/* Media Content */}
          <div className="max-w-full max-h-full w-full flex items-center justify-center px-2 sm:px-4">
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="max-w-full max-h-[85vh] sm:max-h-[90vh] object-contain rounded-lg sm:rounded-xl shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
